module.exports = __webpack_public_path__ + "static/media/A22.00380cfc.png";